import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddCustomerLayer from "../components/AddCustomerLayer";

const AddCustomerPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Customer' />

        {/* BlogLayer */}
        <AddCustomerLayer />
      </MasterLayout>
    </>
  );
};

export default AddCustomerPage;
